import React from 'react'
import Modal from 'components/Modal/Modal';
import Loader from 'components/Loader';
import styles from 'container/rolesManagement/roles.module.scss';

const DeleteFindingModal = ({isOpen,isClose,onDelete,loadingBtn}) => {
  return (
    <div>
         <Modal isOpen={isOpen} isClose={isClose} width={'464'} height={'200'}>
            <div>
              <h2 className={styles.modal__header}>
                Delete Diagnostic Finding
              </h2>
              <div className={styles.modal__caption}>
                <p>
                  Are you sure you want to delete this diagnostic findings?
                </p>
              </div>
              <div className={styles.modal__button}>
                <button className={styles.modal__button_cancel} onClick={isClose}>
                  Cancel
                </button>
                <button
                  className={styles.modal__button_save}
                  data-testid="logout-button"
                  onClick={onDelete}
                >
                  {loadingBtn ? <Loader color="white" /> : 'Delete'}
                </button>
              </div>
            </div>
          </Modal>
    </div>
  )
}

export default DeleteFindingModal